<template>
  <div
    class="page-fault-item tb"
    v-if="funcView.all_fault_manage_list ||funcView.my_fault_manage_list"
  >
    <custom-tab
      :value="type"
      :list="typeData"
      class="tab"
      @input="onTabChange"
    ></custom-tab>
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <!-- 人工解除 - 批量 -->
        <el-form-item v-if="((funcView.all_fault_manage_clear_fault&& type === '1') || ( funcView.my_fault_manage_clear_fault&& type === '2')) && selfPageType === 1">
          <el-button
            :disabled="tableSelect.length === 0"
            type="primary"
            @click="clearFaults(tableSelect)"
          >{{ $t('asm_fault_item.ren_gong_jie_chu') }}</el-button>
        </el-form-item>
        <!-- 导出excel -->
        <el-form-item
          style="float: right; margin-right: 0"
          v-if="exportExcelEnable"
        >
          <el-button
            class="table-set"
            style="vertical-align: top"
            @click="exportTable"
          ><i class="icon icon-daochu"></i></el-button>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item
          style="float: right"
          :class="!exportExcelEnable ? 'mr-0' : ''"
        >
          <search-input
            v-model="formSearch.search"
            @fetch="onPageChange({ page: 1 })"
            :placeholder="$t('asm_fault_item.jshsjdmV3dmV4dm')"
          ></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <el-radio-group
            v-model="selfPageType"
            @change="onPageTypeChange"
          >
            <el-radio-button
              :label="item.value"
              v-for="item in pageTypeData"
              :key="item.value"
            >{{item.label}}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <!-- 更多搜索 -->
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container
      ref="container"
      @search="onPageChange({ page: 1 })"
      @clear="clearFilter()"
    >
      <el-form
        :inline="true"
        label-position="top"
      >
        <!-- 上报时间 -->
        <el-form-item :label="$t('asm_fault_item.shang_bao_shi_jian')">
          <custom-date-picker
            style="width: 100%"
            v-model="formSearch.reportDate"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
          ></custom-date-picker>
        </el-form-item>
        <!-- 解除时间 -->
        <el-form-item :label="$t('asm_fault_item.jie_chu_shi_jian')">
          <custom-date-picker
            style="width: 100%"
            v-model="formSearch.recoverDate"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="pickerOptionsIntervalThreeMonth"
          ></custom-date-picker>
        </el-form-item>
        <!-- 产品型号 -->
        <el-form-item :label="$t('asm_fault_item.chan_pin_xing_hao')">
          <custom-select
            url="productCodeSelectList"
            v-model="formSearch.productCode"
            :props="{ label: 'productCode', value: 'productCode' }"
            width="100%"
          ></custom-select>
        </el-form-item>
        <!-- 部件名称 -->
        <el-form-item :label="$t('asm_fault_item.bu_jian_ming_cheng')">
          <el-input v-model="formSearch.componentName"></el-input>
        </el-form-item>
        <!-- 合同编号 -->
        <el-form-item :label="$t('asm_fault_item.he_tong_bian_hao')">
          <el-input v-model="formSearch.contractNo"></el-input>
        </el-form-item>
        <!-- 租赁方 -->
        <el-form-item :label="$t('asm_fault_item.zu_lin_fang')">
          <el-input v-model="formSearch.customerName"></el-input>
        </el-form-item>
        <!-- 项目 -->
        <el-form-item :label="$t('asm_fault_item.xiang_mu')">
          <el-input v-model="formSearch.locationName"></el-input>
        </el-form-item>
        <!-- 案例单号 -->
        <el-form-item :label="$t('asm_fault_item.an_li_dan_hao')">
          <el-input v-model="formSearch.caseOrderCode"></el-input>
        </el-form-item>
        <!-- 售后公司 -->
        <el-form-item :label="$t('asm_fault_item.shou_hou_gong_si')">
          <el-input v-model="formSearch.afterServiceName"></el-input>
        </el-form-item>
        <!-- 代理公司 -->
        <el-form-item :label="$t('asm_fault_item.dai_li_gong_si')">
          <el-input v-model="formSearch.agentCoName"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        ref="customTb1"
        :type="selfPageType === 1 ? 'checkbox' : 'radio'"
        v-model="tableSelect"
        height="100%"
        :data="tableList"
        :column="tableColumn"
        @sort="sortChange"
        @filter="filterChange"
        index
        :slots="['bodyNum', 'faultDuration', 'recoverTotalTime', 'action']"
      >
        <template v-slot:recoverTotalTime="scope">
          {{scope.row.recoverTotalTime ? Math.ceil(scope.row.recoverTotalTime / 60) : '-'}}h
        </template>
        <template v-slot:faultDuration="scope">
          {{scope.row.faultDuration ? Math.ceil(scope.row.faultDuration / 60) : '-'}}h
        </template>
        <template v-slot:bodyNum="scope">
          <div
            class="cell-link"
            @click="jump('/devicedetail', { deviceId: scope.row.deviceId, parentPath: $route.path })"
          >{{ scope.row.bodyNum }}</div>
        </template>
        <template v-slot:action="scope">
          <span>
            <el-button
              v-if="!scope.row.isCreateCase && ((funcView.all_fault_manage_add_case&& type === '1')||(funcView.my_fault_manage_add_case&& type === '2'))"
              type="text"
              size="mini"
              @click="addCase(scope.row)"
            >{{ $t('asm_fault_item.tian_jia_an_li') }}</el-button>
            <el-button
              v-if="(funcView.all_fault_manage_clear_fault&& type === '1') || (funcView.my_fault_manage_clear_fault&& type === '2')"
              type="text"
              size="mini"
              @click="clearFault(scope.row)"
            >{{ $t('asm_fault_item.ren_gong_jie_chu') }}</el-button>
          </span>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <add-case-dialog
      v-if="addCaseVisible"
      @close="addCaseVisible=false"
      :model="addCaseModel"
      @success="getTableList"
      type="fault"
    ></add-case-dialog>
  </div>
</template>

<script>
import moment from 'moment';
import apis from '@/utils/apis';
import tableFilterValueGetParamMixins from '@/mixins/table_filterValue_getParam_mixins.js';
import addCaseDialog from './add_case_dialog';

export default {
  name: '',
  mixins: [tableFilterValueGetParamMixins],
  components: {
    addCaseDialog
  },
  props: {
    // 1 - 组织设备  2 - 我的设备
    type: [Number, String],
    // 1 - 未解除  2 - 已解除
    // pageType: Number,
  },
  watch: {
    selfPageType(val) {
    // 当 selfPageType 发生变化时，重置 recoverDate 的值
      if (val === 1) {
        this.formSearch.reportDate = [
          this.$momentWorld(moment(this.$getLocalTime()).subtract(90, 'days').startOf('day').format('YYYY-MM-DD 00:00:00')),
          this.$momentWorld(moment(this.$getLocalTime()).format('YYYY-MM-DD 23:59:59'))
        ];
        this.formSearch.recoverDate = [];
      } else if (val === 2) {
        this.formSearch.reportDate = [];
        this.formSearch.recoverDate = [
          this.$momentWorld(moment(this.$getLocalTime()).subtract(90, 'days').startOf('day').format('YYYY-MM-DD 00:00:00')),
          this.$momentWorld(moment(this.$getLocalTime()).format('YYYY-MM-DD 23:59:59'))
        ];
      }
    }
  },
  data() {
    return {
      tableSelect: [],
      link: null,
      selfPageType: 1,
      formSearch: {
        search: '',
        pageSize: 50,
        pageNum: 1,
        // 上报时间
        reportDate: [this.$momentWorld(moment(this.$getLocalTime()).subtract(90, 'days').startOf('day').format('YYYY-MM-DD 00:00:00')), this.$momentWorld(moment(this.$getLocalTime()).format('YYYY-MM-DD 23:59:59'))],
        // 解除时间
        recoverDate: [],

        productCode: '',
        componentName: '',
        contractNo: '',
        // 租赁方
        customerName: '',
        locationName: '',
        // 案例单号
        caseOrderCode: '',
        // 售后公司
        afterServiceName: '',
        // 代理公司
        agentCoName: '',
      },
      tableList: [],
      totalRows: null,
      tableCode: '',
      addCaseVisible: false,
      addCaseModel: {},
    };
  },
  computed: {
    typeData() {
      const typeMap = [];
      if (this.funcView.all_fault_manage_list) {
        typeMap.push({
          value: '1',
          name: this.$t('asm_fault_item.zu_zhi_she_bei')
        });
      }
      if (this.funcView.my_fault_manage_list) {
        typeMap.push({
          value: '2',
          name: this.$t('asm_fault_item.wo_de_she_bei')
        });
      }
      return typeMap;

    },
    pageTypeData() {
      return [
        {
          value: 1,
          label: this.$t('asm_fault_item.wei_jie_chu')
        },
        {
          value: 2,
          label: this.$t('asm_fault_item.yi_jie_chu')
        }
      ];
    },
    exportExcelEnable() {
      // 组织导出
      const faultManageExport = this.funcView.all_fault_manage_export && `${this.type}` === '1';
      // 我的导出
      const faultManageExportHist = this.funcView.my_fault_manage_export && `${this.type}` === '2';

      return faultManageExport || faultManageExportHist;
    }
  },
  filters: {
  },
  directives: {
  },
  methods: {
    exportTable() {
      const url = this.selfPageType === 1 ? apis.faultInfoExport : apis.faultHistExport;
      const reqData = this.getReqData();
      delete reqData.pageSize;
      delete reqData.pageNum;
      this.$exportFlie(url, reqData);
    },
    addCase(item) {
      this.addCaseModel = {
        data: item
      };
      this.addCaseVisible = true;
    },
    // mockAddCase() {
    //   this.addCaseModel = {
    //     data: {}
    //   };
    //   this.addCaseVisible = true;
    // },
    clearFault(item) {
      const { faultInfoId } = item;
      const tips = this.$t('asm_fault_item.nqdyrgjccgzm');
      this.$showConfirm(tips).then(() => {
        this.$postJSON(`${apis.faultClearFault}/${faultInfoId}`).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_handle_success')
          });
          this.getTableList();
        });
      });
    },
    clearFaults(rows) {
      const ids = rows.map(item => item.faultInfoId);
      const tips = this.$t('asm_fault_item.nqdyrgjcxzdgzm');
      this.$showConfirm(tips).then(() => {
        this.$postJSON(apis.faultClearFaultBatch, ids).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_handle_success')
          });
          this.getTableList();
        });
      });
    },
    getReqData() {
      const reqData = {
        ...this.formSearch,
        dataType: `${this.type}` === '2' ? 1 : 2,
      };

      const reportDate = reqData.reportDate;
      const recoverDate = reqData.recoverDate;
      if (reportDate && reportDate.length) {
        reqData.reportStartDate = reportDate[0];
        reqData.reportEndDate = reportDate[1];
      }
      delete reqData.reportDate;

      if (recoverDate && recoverDate.length) {
        reqData.recoverStartDate = recoverDate[0];
        reqData.recoverEndDate = recoverDate[1];
      }
      delete reqData.recoverDate;

      return reqData;
    },
    getReqUrl() {
      return this.selfPageType === 1 ? apis.faultInfoPage : apis.faultHistPage;
    },
    updateTableCode() {
      const tableCodeMap = [
        {
          tableCode: 'fault_manage_not_released',
          tabIndex: '1',
          typeIndex: 1,
        },
        {
          tableCode: 'fault_manage_released',
          tabIndex: '1',
          typeIndex: 2,
        },
        {
          tableCode: 'fault_manage_not_released',
          tabIndex: '2',
          typeIndex: 1,
        },
        {
          tableCode: 'fault_manage_released',
          tabIndex: '2',
          typeIndex: 2,
        }
      ];
      const item = tableCodeMap.find(obj => obj.tabIndex === this.type && obj.typeIndex === this.selfPageType);
      const tableCode = item ? item.tableCode : '';
      this.tableCode = tableCode;

      this.getTableColumn();
    },
    onTabChange(value) {
      this.$emit('tab', value);
      this.$emit('pageTypeChange', 1);
    },
    onPageTypeChange() {
      this.tableSelect = [];
      this.updateTableCode();
      this.onPageChange({ page: 1 });
    },
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 清除
    clearFilter: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.onPageChange({ page: 1 });
    },
    getTableList() {
      const url = this.getReqUrl();
      const reqData = this.getReqData();
      this.$getJSON(url, reqData).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 根据机身号跳转设备详情  /device/mydevice  jump('/devicedetail', { deviceId: scope.row.deviceId, parentPath: $route.path })
    // 根据合同编号跳转合同详情  /contract/management  不符合传参
    // 根据案例单号跳转案例详情  /workorder/caseOrder
  },
  created() {
  },
  mounted() {
    // this.mockAddCase();
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
        if (!this.funcView.all_fault_manage_list && this.funcView.my_fault_manage_list) {
          this.onTabChange('2');
        }
      }, 500);
    });
    this.updateTableCode();
    this.getTableList();
  },
};
</script>

<style lang="scss">
.page-fault-item {
  .tab {
    margin-left: -16px;
    margin-right: -16px;
  }
}
</style>
